import { Link as RouterLink, useLoaderData } from "react-router";

import { OAuthCallbackPage } from "@/shared/components/OAuthCallback/OAuthCallbackPage";
import type { OAuthCallbackView } from "@/shared/components/OAuthCallback/resolveOAuthCallbackView";
import { Goto } from "@/shared/navigation/Goto";

import { renderSlackConnectError } from "./slackOAuthCopy";
import { SLACK_OAUTH_MESSAGES } from "./slackOAuthMessages";

/**
 * Where Slack's OAuth redirect lands. The exchange runs in the route's loader
 * ({@link slackOAuthCallbackLoader}); this renders its outcome.
 */
export function SlackOAuthCallback() {
  const view = useLoaderData<OAuthCallbackView>();

  return (
    <OAuthCallbackPage
      view={view}
      messageTypes={SLACK_OAUTH_MESSAGES}
      successMessage={
        <>
          Slack workspace connected! You can close this window, then pick the
          channels Roboto agents may post to on the{" "}
          <RouterLink to={Goto.route.SlackIntegration}>
            Slack integration page
          </RouterLink>
          .
        </>
      }
      renderError={renderSlackConnectError}
      standaloneRedirectPath={Goto.route.SlackIntegration}
    />
  );
}
